import * as yup from "yup";

const periodValidationSchema = yup.object().shape({
    arrival: yup
        .date()
        .typeError('Deve essere una data valida gg/mm/aaaa')
        .required('Campo obbligatorio'),
    departure: yup
        .date()
        .typeError('Deve essere una data valida gg/mm/aaaa')
        .test(
            'al-least-one-night',
            'Deve essere maggiore rispetto alla data di arrivo',
            (value, testContext) => {
                const {arrival} = testContext.parent;
                return value > arrival
            }
        )
        .test(
            'at-most-2-months',
            'Durata soggiorno deve essere minore o uguale a 2 mesi',
            (value, testContext) => {
                const {arrival} = testContext.parent;
                return value <= new Date(arrival).setMonth(new Date(arrival).getMonth() + 2)
            }
        )
        .required('Campo obbligatorio'),
});

export default periodValidationSchema;